<template>
  <div class="section" id="cont">
    <!--  Header  -->
    <section id="views" class="hero title-card">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Resumen del Resultado de Líderes PHD
          </h1>
          <h2 class="subtitle" v-if="proceso.processComp">
            Comparado con {{ proceso.processComp.nombre }}
          </h2>
        </div>
        <div>
          <span>Fecha de diagnóstico</span>
          <h4 class="has-text-dark">{{ dateProcess(infoProcess.date) }}</h4>
        </div>
      </div>
    </section>

    <!--  Data  -->
    <div class="columns date filters-sticky">
      <div class="column">
        <div class="columns">
          <span
            class="column is-3 has-text-dark has-text-left"
            style="margin: auto !important;"
            >Dependencias:</span
          >
          <div class="column">
            <Multiselect
              :disabled="idLider !== ''"
              v-model="dependencias"
              :options="dependProcess"
              :placeholder="empresa.nombre"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              label="text"
              track-by="text"
              group-values="children"
              group-label="label"
              :group-select="false"
              selected-label="✔"
              select-label="Agregar filtro"
              deselect-label="Eliminar filtro"
              @close="closeSelect"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length"
                  v-show="!isOpen"
                  >{{ textSelectDepend(values) }}</span
                ></template
              >
              <span slot="noResult">0 filtros encontrados.</span>
            </Multiselect>
          </div>
        </div>
      </div>
      <div
        class="column actions-board"
        style="margin-top: 5px; display: flex; justify-content: end; gap: 10px;"
      >
        <a
          v-if="tokenUser && tokenUser.admin"
          href="javascript:void(0)"
          class="button is-small is-dark"
          :disabled="this.validCtx || !!this.dependencias.length"
          v-on:click="switchContext"
          style="gap: 5px"
        >
          <i class="material-icons">language</i>
          <span
            >{{ generalContext.status ? "Ocultar" : "Mostrar" }} Benchmark</span
          >
        </a>
        <a
          href="javascript:void(0)"
          class="button is-small is-dark"
          v-on:click="dwData"
          v-tooltip="'Descargar Resultados'"
        >
          <i class="material-icons">cloud_download</i>
        </a>
      </div>
    </div>

    <!-- SubHeader - Cards Info  -->
    <section style="margin-top: 20px">
      <div class="container columns has-text-centered">
        <div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 has-text-weight-bold">Participación</h1>
            <span class="is-size-3 has-text-dark" v-if="infoProcess"
              >{{
                !!infoProcess.filter
                  ? infoProcess.filter.participation
                  : infoProcess.participation
              }}%</span
            >
          </div>
        </div>
        <div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 has-text-weight-bold">Líderes</h1>
            <span class="is-size-4" v-if="infoProcess"
              ><span v-if="!!infoProcess.filter" class="is-dark"
                >{{ infoProcess.filter.leaders }} de </span
              >{{ infoProcess.leaders }}</span
            >
          </div>
        </div>
        <div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 has-text-weight-bold">Encuestas terminadas</h1>
            <div
              class="is-flex has-text-centered justify-center"
              style="align-items: center; justify-content: center;"
            >
              <span class="is-size-4" v-if="infoProcess"
                ><span v-if="!!infoProcess.filter" class="is-dark"
                  >{{ infoProcess.filter.totalParticipation }} de
                </span>
                {{ infoProcess.totalParticipation }}
              </span>
              <i
                class="material-icons icon-infoCount"
                v-if="infoProcess"
                style="margin-left: 5px;"
                v-tooltip="
                  `<strong class=&quot;has-text-white&quot;>Autoevaluaciones</strong>: ${
                    !!infoProcess.filter
                      ? infoProcess.filter.auto
                      : infoProcess.auto
                  } <br> <strong class=&quot;has-text-white&quot;>Colaboradores</strong>: ${
                    !!infoProcess.filter
                      ? infoProcess.filter.cola
                      : infoProcess.cola
                  }`
                "
                >info</i
              >
            </div>
          </div>
        </div>
        <!--              <div class="column is-parent is-vertical">
                          <div class="box box-sub">
                            <h1 class="is-size-5 has-text-weight-bold">Encuestas eliminadas</h1>
                            <span class="is-size-3">2</span>
                          </div>
                        </div>-->
        <div class="column is-parent is-vertical">
          <div class="box box-sub">
            <h1 class="is-size-5 has-text-weight-bold">Sin Consentimiento</h1>
            <span class="is-size-4" v-if="infoProcess"
              ><span v-if="!!infoProcess.filter" class="is-dark"
                >{{ infoProcess.filter.noConsent }} de </span
              >{{ infoProcess.noConsent }}</span
            >
          </div>
        </div>
      </div>
    </section>

    <!-- SubHeader - General Context -->
    <Transition name="fade">
      <section v-if="generalContext.status" class="content-generalCtx">
        <div class="ranking" :data-number="generalContext.headers.position">
          <img
            src="@/assets/icons/seal-duotone.svg"
            alt="ranking icon"
            width="120"
          />
          <span
            v-tooltip.right="'Posición actual frente al total de empresas'"
            class="tag"
            >Posición Empresa</span
          >
        </div>
        <div class="hero hero-context">
          <div
            class="hero-body has-text-centered"
            style="align-content: center;"
          >
            <div class="container">
              <nav class="level">
                <!-- <div class="iconCtx">
                <img
                  src="@/assets/icons/iconColombia.png"
                  width="80"
                  height="80"
                  alt="colombia"
                />
              </div> -->
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Empresas</p>
                    <p class="title">
                      {{ generalContext.headers.clients || 0 }}
                    </p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Líderes</p>
                    <p class="title">
                      {{ generalContext.headers.leaders || 0 }}
                    </p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Encuestados</p>
                    <p class="title">
                      {{ generalContext.headers.data || 0 }}
                    </p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Años</p>
                    <p class="title">
                      {{ generalContext.headers.min || "--" }} -
                      {{ generalContext.headers.max || "--" }}
                    </p>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>
    </Transition>

    <!--  Section Views  -->
    <div id="views">
      <div class="container">
        <section>
          <ResulParte1
            ref="childComponent1"
            :idLider="idLider"
            :dependencias="dependencias"
            :dataLider="dataLider"
            :lideres="dataLideres"
            :proceso="proceso"
            :generalContext="generalContext"
          ></ResulParte1>
        </section>
        <section>
          <ResulParte2
            ref="childComponent2"
            :proceso="proceso"
            @selectDependencia="selectDependencia"
            :dependencias="dependencias"
            :dataLideres="dataLideres"
            @changeIdLider="changeIdLider"
          ></ResulParte2>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import ResulParte1 from "./ResultadoLiderazgo/ResulParte1.vue";
import ResulParte2 from "./ResultadoLiderazgo/ResulParte2.vue";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import json from "./calificacionLider.json";
const XLSX = require("xlsx");

export default {
  data() {
    return {
      idLider: "",
      dataLider: {},
      dataLideres: {},
      dependencias: [],
      dependProcess: [],
      infoProcess: {},
      generalContext: {
        status: false,
        data: {},
        headers: {},
      },
      value: [],
      cambio: 0,
    };
  },
  computed: {
    ...mapState(["idtoken", "empresa", "tokenUser"]),
    validCtx() {
      return (
        this.isEmpty(this.generalContext.data) &&
        this.isEmpty(this.generalContext.headers)
      );
    },
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  beforeMount() {
    this.$emit("calculateProcess");
  },
  methods: {
    // Data
    async traeResumen() {
      try {
        const result = await apiServices.post(`/resumenlider`, {
          dependencias: this.idLider
            ? []
            : this.setStructureFilters(this.dependencias),
          procesoid: this.proceso._id,
          idLider: this.idLider,
        });

        if (this.proceso.processComp) {
          const resultComp = await apiServices.post(`/resumenlider`, {
            dependencias: this.idLider
              ? []
              : this.setStructureFilters(this.dependencias),
            procesoid: this.proceso.processComp._id,
            idLider: this.idLider,
          });

          result.data.processComp = resultComp.data;
          result.data.processComp.nombre = this.proceso.processComp.nombre;
        }

        if (result.data) {
          this.cambio === 0 ? (this.cambio = 1) : (this.cambio = 0);
          result.data.cambio = this.cambio;
          this.dataLider = result.data;

          if (result.data.infoProcess.dependencia) {
            this.infoProcess.filter = result.data.infoProcess;
          }
          if (result.data.infoProcess.leader["collaborators"] !== null) {
            this.infoProcess.filter = result.data.infoProcess.leader;
          }
          if (
            !result.data.infoProcess.dependencia &&
            result.data.infoProcess.leader["collaborators"] === null
          ) {
            this.infoProcess = result.data.infoProcess;
          }
        }

        let dependencias = { ...result.data.dependencias };

        this.dependProcess = Object.entries(dependencias).map(
          ([key, value]) => {
            return {
              label: key,
              children: value,
            };
          }
        );

        await this.getGeneralContext();
      } catch (err) {
        console.log(err);
      }
    },
    async traerLideres() {
      let result;
      try {
        result = await apiServices.post(`/resultliders/${this.proceso._id}`, {
          dependencias: this.setStructureFilters(this.dependencias),
        });

        if (result.data.data) {
          this.dataLideres = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGeneralContext() {
      try {
        if (this.tokenUser && !this.tokenUser.admin) return;
        const result = await apiServices.get("/generalContext/0");
        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
          this.generalContext.headers.position = this.getPosition(
            result.data.headers
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Filters
    changeIdLider(id) {
      this.idLider = id;
    },
    selectDependencia(depend) {
      this.dependencias = depend;
    },
    // Others
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        el.scrollIntoView({ behavior: "smooth" });
      });
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    subtitle() {
      this.$emit("subtitleResult", this.dataLider.processComp);
    },
    setStructureFilters(dep) {
      const arrayDepend = {
        dependencia: [],
        dependencias: [],
        count: 0,
      };
      dep.map((x) => {
        if (x.index) {
          arrayDepend["dependencias"].push({
            [`dependencias.${x.index}`]: x.value,
          });
        } else {
          arrayDepend["dependencia"].push(x.value);
        }
        arrayDepend.count += 1;
      });
      return arrayDepend;
    },
    async dwData() {
      try {
        const leaders = this.dataLideres.data;
        let result = {
          ...this.dataLider,
          countRange: this.dataLideres.countRange,
        };
        const resultDep = await apiServices.post(`/resultDependencies/`, {
          idProcess: this.proceso._id,
          dependencies: this.dependProcess,
        });
        result = [result, ...resultDep.data];
        let dataResult = [];
        let dataLeaders = await this.excelFormat(leaders, "leaders");

        await Promise.all(
          result.map(async (item) => {
            const result = await this.excelFormat(item, "result");
            dataResult = [...dataResult, ...result];
          })
        );

        const wb = XLSX.utils.book_new();
        let name, ws;
        // Results - Asignamos la información necesaria a nuevas variables
        name = "Resultados";
        //  Se agrega la data al libro de excel
        ws = XLSX.utils.json_to_sheet(dataResult);
        //  Se configura el tamaño de cada columna
        ws["!cols"] = this.widthCols(dataResult);
        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        XLSX.utils.book_append_sheet(wb, ws, name);
        // Leaders Asignamos la información necesaria a nuevas variables
        name = "Resultados lideres";
        //  Se agrega la data al libro de excel
        ws = XLSX.utils.json_to_sheet(dataLeaders);
        //  Se configura el tamaño de cada columna
        ws["!cols"] = this.widthCols(dataLeaders);
        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        XLSX.utils.book_append_sheet(wb, ws, name);

        // Save Excel
        XLSX.writeFile(wb, `Resultados-${this.proceso.nombre}.xlsx`);
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    // Excel
    async excelFormat(datos, name) {
      let data = [];
      let rows;
      const metas = json.metas;
      const ratings = json.calificaciones;
      const names = {
        liderT: "Líder PHD",
        cond: "Gestión del Conocimiento",
        resuld: "Gestión de Resultados",
        cambiod: "Cambio y Toma de Decisiones",
        logrod: "Logro",
        dsmd: "Gestión de Sí Mismo",
        humid: "Humildad",
        autogd: "Autogestión",
        gperd: "Gestión de Personas",
        reld: "Gestión de Relaciones",
        cefectivad: "Comunicación Efectiva",
        asertivad: "Asertividad",
        cercaniad: "Cercanía",
        rad: "Retroalimentación",
      };
      const rangesAuto = {
        0: "Sin resultados",
        1: "Alta",
        2: "Media",
        3: "Bajo",
      };
      const namesRanges = [
        "Sin Resultados",
        "Líder con prioridad de intervención",
        "Líder con oportunidad de mejora",
        "Líder en desarrollo",
        "Líder competente",
        "Líder experta(o)",
        "Líder PHD",
      ];

      try {
        switch (name) {
          case "result":
            rows = Object.keys(names).map((k) => {
              return {
                Grupo: datos.group ? datos.group : "General",
                Dependencia: datos.dependence ? datos.dependence : "General",
                Variable: names[k],
                Colaborador:
                  datos["colaboradores"][k].e > 0
                    ? datos["colaboradores"][k].e.toFixed(2)
                    : 0,
                Autoevaluación:
                  datos["autoevaluacion"][k].e > 0
                    ? datos["autoevaluacion"][k].e.toFixed(2)
                    : 0,
                Autoconciencia: rangesAuto[datos["autoconciencia"][k].r],
                Fuertes:
                  k === "liderT" && datos.countRange
                    ? datos.countRange.lideres[0].toFixed(2) | 0
                    : "",
                Mejorar:
                  k === "liderT" && datos.countRange
                    ? datos.countRange.lideres[1].toFixed(2) | 0
                    : "",
                Rango:
                  k !== "liderT"
                    ? namesRanges[datos["colaboradores"][k].r]
                    : "",
                Calificación:
                  k !== "liderT" ? ratings[k][datos["colaboradores"][k].r] : "",
                "Meta a proponerse en puntos":
                  metas[datos["colaboradores"][k].e.toFixed(0)],
              };
            });
            data = rows;
            break;
          case "leaders":
            rows = datos.map((v, key) => {
              Object.keys(names).map((k) => {
                data.push({
                  Líder: v["empleado"].nombre,
                  Variable: names[k],
                  Colaborador:
                    v["colaboradores"][k].e > 0 ? v["colaboradores"][k].e : 0,
                  Autoevaluación:
                    v["autoevaluacion"][k].e > 0 ? v["autoevaluacion"][k].e : 0,
                  Autoconciencia: rangesAuto[v["autoconciencia"][k].r],
                  Rango: namesRanges[v["colaboradores"][k].r],
                  Calificación:
                    k !== "liderT" ? ratings[k][v["colaboradores"][k].r] : "",
                  "Meta a proponerse en puntos":
                    metas[v["colaboradores"][k].e.toFixed(0)],
                });
              });
            });
            break;
        }
        return data;
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    // General Context
    switchContext() {
      if (this.validCtx || !!this.dependencias.length) return;
      this.generalContext.status = !this.generalContext.status;
      this.cambio ? (this.cambio = 0) : (this.cambio = 1);
    },
    getPosition(headers) {
      const lidert = this.dataLider.colaboradores.liderT.e;
      if (!lidert) return "-";
      const position = headers.ranking.avg_lidert_e.filter(
        (value) => value.avg_lidert_e > lidert
      ).length;
      return position + 1;
    },
    // Select Dependencies
    textSelectDepend(values) {
      if (values.length === 1) {
        return values[0].text;
      }
      return `${values.length} filtros aplicados`;
    },
    closeSelect(values) {
      // this.traeResumen()
    },
    // Helpers
    widthCols(data) {
      let values = [];

      // Recorre todos los datos
      for (const currentRow of data) {
        // Recorre la información de un Dato
        let columnIndex = 0;
        for (const columnName in currentRow) {
          const cellValueLength = String(currentRow[columnName]).length + 2;

          // Si es la primera iteración o el valor actual es mayor al almacenado en values, actualiza el valor
          if (
            !values[columnIndex] ||
            values[columnIndex].width < cellValueLength
          ) {
            values[columnIndex] = { width: cellValueLength };
          }

          columnIndex++;
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let cellValueLength = String(key).length + 2;
        if (values[cont].width < cellValueLength) {
          values[cont] = { width: cellValueLength };
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values;
    },
    isEmpty(ele) {
      if (ele === undefined) return true;
      if (typeof ele === "object") return Object.keys(ele).length === 0;
      return ele.length === 0;
    },
  },
  mounted() {
    this.autoScroll();
  },
  created() {
    this.traeResumen();
    this.traerLideres();
  },
  watch: {
    idLider() {
      this.traeResumen();
    },
    dependencias() {
      if (this.dependencias.length) this.generalContext.status = 0;
      if (this.idLider === "") {
        this.traeResumen();
        this.traerLideres();
      }
    },
    "dataLider.processComp"() {
      this.subtitle();
    },
  },
  components: {
    Multiselect,
    ResulParte1,
    ResulParte2,
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.is-primary {
  color: #134f5c !important;
}

.is-red {
  color: red;
}

.date {
  margin-top: 10px;
  margin-left: 2px;
}

.box-sub {
  height: 118px !important;
}

.filters-sticky {
  background-color: white;
  position: sticky !important;
  top: 0;
  z-index: 55;
}

.content-generalCtx {
  position: relative;
  display: flex;
  margin-top: 25px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    top: -5px;
  }
}

.hero-context {
  border-radius: 10px !important;
  background-color: #d27ff93e !important; // #f3f3f3
  width: 100%;
  @media screen and (max-width: 768px) {
    padding-top: 20px;
    border-top: #510087 solid;
  }
}

.hero-context .hero-body {
  padding: 35px !important;
}

.hero-context .iconCtx {
  border-right: 3px solid #d27ff93e;
  padding-right: 30px;
}

.ranking {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  @media screen and (max-width: 768px) {
    bottom: -39px;
    margin-right: 0 !important;
  }
}

.ranking .tag {
  position: relative;
  background-color: #510087;
  font-weight: 800;
  color: white;
  top: -12px;
}

.ranking::before {
  content: attr(data-number);
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-size: 2rem;
  font-weight: bold;
  pointer-events: none;
}

.actions-board .is-small {
  border-radius: 4px;
}

.icon-infoCount {
  font-size: 20px !important;
  color: #a9a9a9 !important;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

.title-card .hero-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Resultados.vue